






















































































import { Component, Vue } from 'vue-property-decorator';
import LayerPopup from '@/components/LayerPopup.vue';
import {
  GetWorkspaceAdminAppsAppNoRequest,
  DomainType,
  PostWorkspaceAdminAppsAppNoInstalledRequest,
  GetAppsAppNoInstalledRequest,
  PostWorkspaceAdminAuthTokenServerApiCodeRequest,
  WorkspaceAdminAppsAppNo,
  DeleteAppsAppNoInstalledRequest,
} from 'supporter';
import { ncpPopup } from '@/utils/ncp';
import Axios from 'axios';

interface GetReadTermsResponse {
  termsType: string;
  contents: string;
  enforcementDateTime: string;
}

interface Authority {
  domainLabel: string;
  authorityLabel: string;
  description: string;
}

interface PopUpRequestDataType {
  id: string;
  hasConfirmBtn: boolean;
  hasCloseBtn: boolean;
  noTitle: boolean;
  nonFooter: boolean;
  hasHeaderCloseBtn: boolean;
  width: number;
  maxHeight: number;
}

const DOMAIN_TO_LABEL_MAP: Record<DomainType, string> = {
  ADMIN: 'admin',
  DELIVERY: 'delivery',
  DISPLAY: 'display',
  MANAGE: 'manage',
  MEMBER: 'member',
  ORDER: 'order',
  ORDER_FRIENDS: 'order-friends',
  PRODUCT: 'product',
  PROMOTION: 'promotion',
  CLAIM: 'claim',
  WORKSPACE: 'workspace',
};
//NOTE: 1024 localhost 용 
const KAKAO_SYNC_APP_NO = process.env.VUE_APP_KAKAO_SYNC_APP_NO ?? '1024';
const KAKAO_SYNC_NOT_INSTALLED_ERROR_CODE = 'AP0004';
const SUCCESS = 200;

@Component({
  components: {
    LayerPopup,
  },
})
export default class KakaoSyncSettingForm extends Vue {
  private readonly mallNo: string = this.$route.params.id;
  private isSendPopUpShow: boolean = false;

  private kakaoSyncInfo: null | WorkspaceAdminAppsAppNo = null;
  private authorities: Authority[] = [];
  private authorizationCode: null | string = null;
  private appUrl: null | string = null;
  private termsContent: null | string = null;

  private async openKakaoSyncDetailLayerPopup() {
    this.isSendPopUpShow = true;
  }

  private closePopup() {
    this.isSendPopUpShow = false;
  }

  private kakaoSyncAccessToken: boolean = false;

  get isInstalled() {
    return this.kakaoSyncAccessToken;
  }

  private sendPopUpRequestData: PopUpRequestDataType = {
    id: 'kakaoSyncSetting',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    noTitle: true,
    nonFooter: true,
    hasHeaderCloseBtn: false,
    width: 700,
    maxHeight: 1000,
  };

  //앱 상세 조회 api (설치 전)
  private async getKakaoSyncInfo() {
    const request: GetWorkspaceAdminAppsAppNoRequest = {
      pathParams: {
        appNo: KAKAO_SYNC_APP_NO,
      },
    };
    const { data } = await this.$api.getWorkspaceAdminAppsAppNo(request);
    this.fetchAuthorities(data.writableAuthorities, data.readableAuthorities);
    this.kakaoSyncInfo = data;
    this.kakaoSyncInfo.privacyAgreement = data.privacyAgreementInfo?.memberPolicy?.replaceAll('\n','<br>') ?? '';
  }

  private fetchAuthorities(writableAuthorities: DomainType[], readableAuthorities: DomainType[]) {
    this.authorities = writableAuthorities
      .map<Authority>((domainType) => ({
        domainLabel: DOMAIN_TO_LABEL_MAP[domainType],
        authorityLabel: this.$t('MALL_FORM_READ_WRITE').toString(),
        description: this.$t('MALL_FORM_AUTHORITY_DESCRIPTION', {
          domain: this.$t(`MALL_FORM_${domainType}_DESCRIPTION`),
          authority: this.$t('MALL_FORM_READ_WRITE_DESCRIPTION'),
        }).toString(),
      }))
      .concat(
        readableAuthorities.map<Authority>((domainType) => ({
          domainLabel: DOMAIN_TO_LABEL_MAP[domainType],
          authorityLabel: this.$t('MALL_FORM_READ').toString(),
          description: this.$t('MALL_FORM_AUTHORITY_DESCRIPTION', {
            domain: this.$t(`MALL_FORM_${domainType}_DESCRIPTION`),
            authority: this.$t('MALL_FORM_READ_DESCRIPTION'),
          }).toString(),
        }))
      );
  }

  //앱 설치 api
  private async postKakaoSyncInstall() {
    const request: PostWorkspaceAdminAppsAppNoInstalledRequest = {
      pathParams: {
        appNo: KAKAO_SYNC_APP_NO,
      },
      data: {
        appPaymentType: 'FREE',
        mallNo: Number(this.mallNo),
        agreed: !!this.agreeApiPermission.length,
      },
    };
    await this.$api.postWorkspaceAdminAppsAppNoInstalled(request);
  }

  //앱 상세조회 api(설치 후)
  private async getKakaoSyncInstalled() {
    const request: GetAppsAppNoInstalledRequest = {
      pathParams: {
        appNo: KAKAO_SYNC_APP_NO,
      },
      params: {
        mallNo: Number(this.mallNo),
      },
    };

    try {
      const {status} = await this.$api.getAppsAppNoInstalled(request); // 호출 여부로 앱 설치 판단
      if (status === SUCCESS) {
        this.kakaoSyncAccessToken = true;
      }
    } catch (err) {
      if (err.data.code === KAKAO_SYNC_NOT_INSTALLED_ERROR_CODE) {
        this.kakaoSyncAccessToken = false;
      }
    }
  }

  //앱 삭제 요청 api
  private async deleteKakaoSyncApp() {
    const request: DeleteAppsAppNoInstalledRequest = {
      pathParams: {
        appNo: KAKAO_SYNC_APP_NO,
      },
      params: {
        mallNo: Number(this.mallNo),
      },
    };
    await this.$api.deleteAppsAppNoInstalled(request);
  }

  // 서버 코드 발행 api
  private async postAuthorizationCode() {
    const request: PostWorkspaceAdminAuthTokenServerApiCodeRequest = {
      data: {
        appNo: KAKAO_SYNC_APP_NO,
        mallNo: Number(this.mallNo),
      },
    };
    const { data } = await this.$api.postWorkspaceAdminAuthTokenServerApiCode(request);
    this.authorizationCode = data.code;
    this.appUrl = data.appUrl;
  }

  // 이용약관 조회 api
  private async getReadTerms() {
    const {data} = await Axios.get(`${process.env.VUE_APP_COMMERCE_URL}/api/read-terms.gd?termsType=APPSTORE`);
    this.termsContent = data.contents.replaceAll('\n','<br/>');
  }

  private created() {
    this.getKakaoSyncInstalled();
    this.getKakaoSyncInfo();
    this.getReadTerms();
  }

  private async openKakaoSyncSettingPopup() {
    await this.postAuthorizationCode();
    const popupUrl = `${this.appUrl}?code=${this.authorizationCode}`;

    ncpPopup(popupUrl, '_blank', 800, 900);
  }

  private async agreeAndRunApp() {
    if (this.validation()) {
      await this.postKakaoSyncInstall();

      alert(this.$t('MALL_FORM_APP_INSTALL_COMPLETE_ALERT').toString());
      location.reload();
    }
  }

  private validation(): boolean {
    if (!this.agreeApiPermission?.length) {
      alert(this.$t('MALL_FORM_NO_PERMISSION_AGREE_ALERT').toString());
      (this.$refs.agreeApiPermission as HTMLTextAreaElement).focus();
      return false;
    }
    return true;
  }

  private agreeApiPermission: (string | number)[] = [];

  private async deleteApp() {
    if (confirm(this.$t('MALL_FORM_DELETE_CONFIRM_MESSAGE').toString())) {
      await this.deleteKakaoSyncApp();
      alert(this.$t('MALL_FORM_APP_DELETE_COMPLETE_ALERT').toString());
      location.reload();
    }
  }
}
